var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pattern-operator-information",attrs:{"align-center":""}},[_c('c-pattern-operator-chip',{staticClass:"mr-4"},[_vm._t("default")],2),_c('div',{staticClass:"pattern-operator-information__bracket"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }